import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>NAK ENGINEERING LTD</h3>
          <p>Innovative Industrial Automation Solutions for Modern Industry</p>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li><a href="#plc">PLC Programming</a></li>
            <li><a href="#microchip">Microchip Development</a></li>
            <li><a href="#cloud">Cloud Computing</a></li>
            <li><a href="#iot">IoT Devices</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p>Website: nakengineering.com</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} NAK ENGINEERING LTD. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
